export default __webpack_public_path__ + "static/media/Anuphan-Medium.c60a08e5.eot";